import { FaCircle } from "react-icons/fa"
import { RiChatAiLine } from "react-icons/ri";
import { Theme } from "../../config/constants";
import { useRef } from "react";

const MinimizedChatbot = (props) => {
    const minimizedChatbotRef = useRef(null)

    const handleOnClick = () => {
        minimizedChatbotRef.current.style.visibility = 'hidden'
        document.getElementById('chatbotContainer').style.visibility = 'visible'
        document.getElementById('chatbotIframe').style.visibility = 'visible'
    }

    return (
        <div id='minimizedChatbotContainer' ref={minimizedChatbotRef} style={{position: 'fixed', right: '-20px', bottom: '10px', zIndex: '201', visibility: 'hidden', cursor: 'pointer'}} onClick={handleOnClick}>
            <FaCircle size={72} color={Theme().colors.accent} />
            <RiChatAiLine size={32} color={'white'} style={{position: 'relative', left: '-51px', top: '1px'}}/>
        </div>
    )
}

export default MinimizedChatbot;